import { GETWithToken } from "./base-service";

const API_URL = "/api/user/v1/me";

export function getCurrentUser(machineId) {
  const url = `${API_URL}?machineId=${machineId}`;
  return GETWithToken(url);
}